import { render, staticRenderFns } from "./OfficialRecommend.vue?vue&type=template&id=b52cd16e&scoped=true"
import script from "./OfficialRecommend.vue?vue&type=script&lang=js"
export * from "./OfficialRecommend.vue?vue&type=script&lang=js"
import style0 from "./OfficialRecommend.vue?vue&type=style&index=0&id=b52cd16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52cd16e",
  null
  
)

export default component.exports